import React from "react";
import { Eyebrow } from "../../components/Primitives";

const REVIEWS = [
    { name: "@maddielate", date: "2 days ago", body: "ok this called me out so hard, finally know why I keep dating the same guy on repeat. genuinely shook." },
    { name: "@nat_thinks", date: "1 week ago", body: "i've taken every quiz on the internet. nothing has been this specific. every line. felt." },
    { name: "@itscarmenj", date: "3 weeks ago", body: "i screamed reading my blind spots. the part about confusing anxiety with passion????? GOODBYE." },
    { name: "@its.aileen", date: "1 month ago", body: "feels like therapy in 5 minutes. sent it to my group chat and now we all know each other's archetypes." },
    { name: "@joelle.bay", date: "1 month ago", body: "the writing is so good. it's not a personality test, it's a love letter that knows exactly where you've been." },
    { name: "@dahlia_w", date: "2 months ago", body: "i've never felt more seen by an app. now i actually understand why i kept attracting the same person." },
    { name: "@lalalena", date: "2 months ago", body: "feels weirdly like the universe wrote it. or my therapist. either way: i'm changed." },
    { name: "@parkerlee", date: "3 months ago", body: "I bought the yearly within 30 seconds. worth every cent. tell your friends." },
];

const STAR_INDEXES = [0, 1, 2, 3, 4];

function ReviewCard({ name, date, body }) {
    return (
        <div className="border border-burgundy/15 p-4 bg-cream">
            <div className="flex justify-between items-center text-[10px] tracking-[0.28em] uppercase">
                <span className="text-burgundy">{name}</span>
                <span className="text-ink-muted">{date}</span>
            </div>
            <div className="mt-2 flex gap-0.5 text-gold">
                {STAR_INDEXES.map(j => (
                    <svg key={`rev-star-${j}`} width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 .587l3.668 7.431 8.2 1.193-5.934 5.78 1.401 8.166L12 18.896l-7.335 3.861 1.401-8.166L.132 9.211l8.2-1.193z" />
                    </svg>
                ))}
            </div>
            <p className="mt-2 font-display text-base leading-snug text-ink">{body}</p>
        </div>
    );
}

export default function PaywallReviews() {
    return (
        <section className="snap-start min-h-[52vh] flex flex-col px-7 py-10">
            <Eyebrow>What women are saying</Eyebrow>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl leading-[1.1] text-burgundy">
                <span className="italic">Five stars</span>, eight times over.
            </h2>
            <div className="mt-6 space-y-4">
                {REVIEWS.map(r => (
                    <ReviewCard key={`${r.name}-${r.date}`} {...r} />
                ))}
            </div>
        </section>
    );
}
